import { render, staticRenderFns } from "./FieldTipoCliente.vue?vue&type=template&id=4d35302f&scoped=true&lang=pug"
import script from "./FieldTipoCliente.vue?vue&type=script&lang=js"
export * from "./FieldTipoCliente.vue?vue&type=script&lang=js"
import style0 from "./FieldTipoCliente.vue?vue&type=style&index=0&id=4d35302f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35302f",
  null
  
)

export default component.exports